// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundPayor {
    'cardholderFirstName'?: string | null;
    'cardholderLastName'?: string | null;
    'medical'?: string | null;
    'planType'?: string | null;
    'planGroup'?: string | null;
    'effectiveDate'?: string | null;
    'expirationDate'?: string | null;
    'npi'?: string | null;
    'rxId'?: string | null;
    'rxBin'?: string | null;
    'rxPCN'?: string | null;
    'rxGroup'?: string | null;
    'cardholderRelationshipToPatient'?: string | null;
    'cardholderName'?: string | null;
    'cardholderDob'?: string | null;
    'cardholderEmployer'?: string | null;
    'personCode'?: string | null;
    'kindOfHealthInsurance'?: string | null;
    'terminationDate'?: string | null;
    'pbmMemberId'?: string | null;
    'insuranceSubType'?: string | null;
    'medicalInsurance'?: string | null;
    'medicalInsuranceId'?: string | null;
    'prescriptionInsurance'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundPayor>> = [
        {
            "name":     "cardholderFirstName",
            "baseName": "cardholderFirstName",
            "type":     "string"
        },
        {
            "name":     "cardholderLastName",
            "baseName": "cardholderLastName",
            "type":     "string"
        },
        {
            "name":     "medical",
            "baseName": "medical",
            "type":     "string"
        },
        {
            "name":     "planType",
            "baseName": "planType",
            "type":     "string"
        },
        {
            "name":     "planGroup",
            "baseName": "planGroup",
            "type":     "string"
        },
        {
            "name":     "effectiveDate",
            "baseName": "effectiveDate",
            "type":     "string"
        },
        {
            "name":     "expirationDate",
            "baseName": "expirationDate",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "rxId",
            "baseName": "rxId",
            "type":     "string"
        },
        {
            "name":     "rxBin",
            "baseName": "rxBin",
            "type":     "string"
        },
        {
            "name":     "rxPCN",
            "baseName": "rxPCN",
            "type":     "string"
        },
        {
            "name":     "rxGroup",
            "baseName": "rxGroup",
            "type":     "string"
        },
        {
            "name":     "cardholderRelationshipToPatient",
            "baseName": "cardholderRelationshipToPatient",
            "type":     "string"
        },
        {
            "name":     "cardholderName",
            "baseName": "cardholderName",
            "type":     "string"
        },
        {
            "name":     "cardholderDob",
            "baseName": "cardholderDob",
            "type":     "string"
        },
        {
            "name":     "cardholderEmployer",
            "baseName": "cardholderEmployer",
            "type":     "string"
        },
        {
            "name":     "personCode",
            "baseName": "personCode",
            "type":     "string"
        },
        {
            "name":     "kindOfHealthInsurance",
            "baseName": "kindOfHealthInsurance",
            "type":     "string"
        },
        {
            "name":     "terminationDate",
            "baseName": "terminationDate",
            "type":     "string"
        },
        {
            "name":     "pbmMemberId",
            "baseName": "pbmMemberId",
            "type":     "string"
        },
        {
            "name":     "insuranceSubType",
            "baseName": "insuranceSubType",
            "type":     "string"
        },
        {
            "name":     "medicalInsurance",
            "baseName": "medicalInsurance",
            "type":     "string"
        },
        {
            "name":     "medicalInsuranceId",
            "baseName": "medicalInsuranceId",
            "type":     "string"
        },
        {
            "name":     "prescriptionInsurance",
            "baseName": "prescriptionInsurance",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundPayor.attributeTypeMap;
    }
}
